module.exports = __webpack_public_path__ + "img/banner.bc7784bf.png";